import Api from '../global/api';  
const metaReducer = (state = {
    status: 'LOADING',
    msg: '',
    data: {}
}, action) => {
    const current_data = JSON.parse(JSON.stringify(state));
    const status = typeof action.status !== 'undefined' ? action.status.toUpperCase(): null;

    switch(action.type){
        case "META_LOAD":
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            break;
        default:
    }
    return state;
}

export default metaReducer;